import { render, staticRenderFns } from "./proposal-form.vue?vue&type=template&id=5c3b4ecc"
import script from "./proposal-form.vue?vue&type=script&lang=js"
export * from "./proposal-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports